import { render, staticRenderFns } from "./pic.vue?vue&type=template&id=352922b8"
import script from "./pic.vue?vue&type=script&lang=js"
export * from "./pic.vue?vue&type=script&lang=js"
import style0 from "./pic.vue?vue&type=style&index=0&id=352922b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports